export const APP_ROUTER_PATHS = {
  HOME: '/',
  GAME: '/game',
  PLAY_VS_COMPUTER: '/play-vs-computer',
  PLAY_VS_PLAYER: '/play-vs-player',
  ABOUT: '/about',
  NOT_FOUND: '/not-found',
};
